export const NODE_TYPES = {
  ACTIVITY: 'activity',
  TASK: 'task',
  GROUP: 'group',
  MILESTONE_START: 'milestoneStart',
  MILESTONE_INTERIM: 'milestoneInterim',
  MILESTONE_END: 'milestoneEnd',
  SEARCH_BOX: 'searchBox',
  CONNECT_FROM: 'connectFrom',
  CONNECT_TO: 'connectTo',
  TEXT_BOX: 'text',
  EMPTY: 'empty',
  IMAGE: 'image'
} as const;
